import { Box, Typography } from "@mui/material";

export function PlatformCheckDetailsTab() {
  return (
    <Box sx={{ py: 4 }}>
      <Typography variant="body1" color="text.secondary">
        Check details content coming soon...
      </Typography>
    </Box>
  );
}
